import React from "react";
import { Route, Routes } from "react-router-dom";

import AssignmentOverview from "./AssignmentsOverview";
import AssignmentGroupsOverview from "./AssignmentGroupsOverview";
import AssignmentGroupView from "./AssignmentGroupView";
import AssignmentView from "./AssignmentView";
import AnswerView from "./AnswerView";
import {
  DirectStudentAnswerUploaderSingleStudentView,
  DirectStudentAnswerUploaderMultiStudentView,
} from "./DirectStudentAnswerUploader";
import AssignmentUploadPage from "./AssignmentUploadPage";
import SubmissionHub from "../components/SubmissionHub";
import AssignmentCreate from "./AssignmentCreate";
import AssignmentCreateFromExisting from "./AssignmentCreateFromExisting";
import AssignmentTemplateView from "./AssignmentTemplateView";
import AnswerAnonymousView from "./AnswerAnonymousView";
import AssignmentCreateNew from "./AssignmentCreateNew";
import AssignmentQuestionView from "./AssignmentQuestionView";
import AssignmentOverviewStudent from "./AssignmentsOverviewStudent";
import StudentAssignmentView from "./StudentAssignmentView";
import { NavigateToLoginWithRedirect } from "../../../routes/helpers/NavigateToLoginWithRedirect";

export const PrivateAssignmentRoutes = ({
  teacher = false,
  student = false,
}) => {
  if (student) {
    // TODO: add in assignment overview with 'student' parameter
    return (
      <Routes>
        <Route path="/" element={<AssignmentOverviewStudent />} />
        <Route
          path="/view/:assignmentId"
          element={<StudentAssignmentView />} // TODO: summary of assignment / redirect to assignment question if only one
        />
        <Route
          path="/answer/upload/student/:id"
          element={<DirectStudentAnswerUploaderSingleStudentView />}
        />
      </Routes>
    );
  }
  return (
    <Routes>
      <Route path="/" element={<AssignmentOverview />} />
      <Route path="/groups" element={<AssignmentGroupsOverview />} />
      <Route
        path="/groups/:assignmentGroupId"
        element={<AssignmentGroupView />}
      />
      <Route path="/create" element={<AssignmentCreate />} />
      <Route path="/create/new" element={<AssignmentCreateNew />} />
      <Route
        path="/create/from-existing"
        element={<AssignmentCreateFromExisting />}
      />
      <Route
        path="/view/template/:assignmentTemplateId"
        element={<AssignmentTemplateView />}
      />

      {teacher && (
        <>
          <Route
            path="/view/:assignmentId/questions/view/:assignmentQuestionId"
            element={<AssignmentQuestionView />}
          />
          <Route
            path="/answer/view/:assignmentId/:studentId"
            element={<AnswerView />}
          />
          <Route
            path="/answer/view/anonymous/:answerId"
            element={<AnswerAnonymousView />}
          />
          <Route
            path="/answer/upload/:id"
            element={<DirectStudentAnswerUploaderMultiStudentView />}
          />
          <Route path="/view/:assignmentId" element={<AssignmentView />} />
          <Route
            path="/upload/:assignmentId"
            element={<AssignmentUploadPage />}
          />
          <Route
            path="/submission-hub/:assignmentId"
            element={<SubmissionHub />}
          />
          <Route
            path="/submission-hub/group/:assignmentGroupId"
            element={<SubmissionHub />}
          />
        </>
      )}
    </Routes>
  );
};

export const PublicAssignmentRoutes = () => {
  return (
    <Routes>
      <Route
        path="/answer/upload/:id"
        element={<DirectStudentAnswerUploaderMultiStudentView />}
      />
      <Route
        path="/answer/upload/student/:id"
        element={<DirectStudentAnswerUploaderSingleStudentView />}
      />
      <Route path="/upload/:assignmentId" element={<AssignmentUploadPage />} />
      <Route path="*" element={<NavigateToLoginWithRedirect />} />
    </Routes>
  );
};
